import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private readonly _toastCtrl: ToastController,
    private readonly _translate: TranslateService,
  ) {
  }

  /**
   * Show Toast
   */
  public async showToast(
    message: string,
    duration: number = 60000,
    color?: string,
    keyboardClose: boolean = true
  ) {
    const toast = await this._toastCtrl.create({
      position: 'top',
      message,
      duration,
      color: color ?? undefined,
      keyboardClose,
      buttons: [
        {
          text: '✖',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });

    toast.present();
  }

}